export const formatBookingAmount = (n?: number | null) => {
  if (n === undefined || n === null) return '0 FCFA';
  return n.toLocaleString('fr-FR') + ' FCFA';
};

export const formatBookingDate = (dateString?: string | null) => {
  if (!dateString) return '—';

  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;

    return date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  } catch {
    return dateString;
  }
};
